import { useEffect, useState } from "react";

export function useElementHeight() {
  // A callback ref, so an element that mounts after the first render — the
  // price bar's sheet, which appears once there is a breakdown — is observed
  // too. An object ref read in a mount-only effect never saw it.
  const [element, setElement] = useState<HTMLElement | null>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (!element) {
      return;
    }

    const resizeObserver = new ResizeObserver(([entry]) => {
      requestAnimationFrame(() => {
        if (!entry) {
          return;
        }
        setHeight(entry.target.getBoundingClientRect().height);
      });
    });

    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, [element]);

  return { ref: setElement, height };
}
